import React, { Component } from "react";

import Error from "./components/Error";
class ErrorPage extends Component {
  render() {
    return (
        <Error history={this.props.history} match={this.props.match} />
    );
  }
}

export default ErrorPage;
